<template>
  <div class="app">
		<div class="row">
			<div class="col-md-12">
				<div class="box">
					<div class="box-header with-border">
						<h3 class="box-title">Режим "Live Custom"</h3>
					</div>
					<div class="box-body">
						<div class="input">
							<input type="text" ref="input" v-model="form.input" class="form-control" @keyup="keyup" placeholder="Просто начните писать фамилию...">
						</div>

						<table v-if="items.length > 0" class="table no-margin">
							<thead>
								<tr>
									<th>ФИО</th>
									<th>ID места</th>
									<th>Место</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, key) in items" v-bind:key="key" >
									<td>{{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}</td>
									<td>{{ item.seat_id }}</td>
									<td><span :class="'label label-' + getCategoryClass(item.category)">{{ item.seat }}</span></td>
									<td>
										<dropdown menu-right>
											<btn class="dropdown-toggle">Действие <span class="caret"></span></btn>
											<template slot="dropdown">
												<li><a role="button" @click="modalHandler(item.revision_id, item.seat_id)">QR код</a></li>
												<li><a role="button" @click="print(item)">Печать QR кода</a></li>
											</template>
										</dropdown>
									</td>
								</tr>
								</tbody>
							</table>
					</div>
					<div class="box-footer">
						<router-link to="/" class="btn btn-default btn-flat pull-left">Вернуться к схеме бронирования</router-link>
						<router-link to="/live" class="btn btn-info btn-flat pull-right">Автоматический режим</router-link>
					</div>
				</div>
			</div>
		</div>
		<modal v-model="modal" title="QR код" @hide="closeModalHandler" ref="modal">
			<div slot="footer">
        <btn type="info" @click="modal=false">OK</btn>
      </div>
			<div class="modal-body">
				<div class="qr-code-wrap">
					<qrcode v-bind:value="qrCodeStr" :options="{ size: 200 }"></qrcode>
				</div>
			</div>
    </modal>
		<div v-show="Object.keys(ticket).length > 0" id="print-area" class="print-area" style="font-family: 'Roboto', sans-serif;padding: 5px;margin: 0 auto;text-align: center;">
			<div class="print-area__username" style="font-size: 25px;font-weight: bold;">{{ ticket.first_name }}<br>{{ ticket.last_name }}</div>
			<barcode class="print-area__barcode" v-bind:value="ticket.seat_id" height="20" display-value="false">
			</barcode>
			<div class="print-area__seat" style="	font-weight: bold;text-transform: uppercase;">{{ ticket.seat }}</div>
		</div>
	</div>
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
	components: {
		'barcode': VueBarcode
	},
	data: function () {
		return {
			modal: false,
			alert: false,
			alertText: '',
			items: [],
			loading: true,
			ticket: {},
			form: {
				input: ''
			},
			qrCodeStr: ''
		}
	},
	mounted: function () {
		this.$refs.input.focus()
	},
	methods: {
		keyup: function () {
			if (this.form.input.length < 3) {
				return false
			}

			this.$http.get('https://tip24.ru/event/ajax/search', {
				params: {
					q: this.form.input,
					event_id: this.getQueryVariable('id')
				}
			}, {
			}).then(function (response) {
				this.items = response.body
				console.log(this.items)
			}, function (response) {
			})
		},
		print: function (data) {
			this.ticket = data
			let win = window.open('', '', 'toolbar=0,scrollbars=1,status=0')
			setTimeout(() => {
				let html = document.getElementById('print-area')
				let bs = '<link href="https://fonts.googleapis.com/css?family=Roboto:400,700,900" rel="stylesheet">'
				win.document.write(bs)
				win.document.write(html.outerHTML)
				setTimeout(() => {
					win.print()
					win.close()
					this.ticket = {}
				}, 300)
			}, 100)
		},
		getCategoryClass: function (val) {
			let categories = {
				vip: 'danger',
				business: 'warning',
				standard: 'default'
			}
			return categories[val]
		},
		getCategoryText: function (val) {
			let categories = {
				vip: 'VIP',
				business: 'Бизнес',
				standard: 'Стандарт'
			}
			return categories[val]
		},
		modalHandler: function (revisionId, seatId) {
			this.qrCodeStr = JSON.stringify({reservation_id: revisionId, ticket_id: seatId})
			console.log(this.qrCodeStr)
			this.modal = true
		},
		closeModalHandler: function (e) {
			if (e === 'dismiss') {
				this.open = false
				this.qrCodeStr = ''
			}
		},
		getQueryVariable: function (name) {
			var query = window.location.search.substring(1)
			var vars = query.split('&')
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (decodeURIComponent(pair[0]) === name) {
					return decodeURIComponent(pair[1])
				}
			}
		},
		reset: function () {
			this.form.input = ''
			this.ticket = {}
		}
	}
}
</script>
<style>
.qr-code-wrap {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/live-custom.vue